import { PreviewSupportedFileType } from '$shared/constants/PreviewSupportedFileType';
import type PdfJs from '$provider/models/PdfJs';
import { FilePreview } from './FilePreview';

export class PdfPreview extends FilePreview<PdfJs> {
  constructor(data: PdfJs) {
    super(PreviewSupportedFileType.Pdf, data);
  }
}
